<script>
    import { Route, Router, useLocation } from 'svelte-routing';

    import Footer from '../components/Footer.svelte';
    import Header from '../components/Header.svelte';

    import ConfigureServices from '../views/purchase/01ConfigureServices.svelte';
    import AccountDetails from '../views/purchase/025AccountDetails.svelte';
    import DataFiles from '../views/purchase/10DataFiles.svelte';
    import VerificationCode from '../views/purchase/10VerificationCode.svelte';
    import DeliveryType from '../views/purchase/03DeliveryType.svelte';
    import Calendar from '../views/purchase/05Calendar.svelte';
    import Payment from '../views/purchase/06Payment.svelte';
    import Welcome from '../views/purchase/07Welcome.svelte';
    import ServiceAddress from '../views/purchase/08ServiceAddress.svelte';
    import Summary from '../views/purchase/09Summary.svelte';
    import { isStep5Or6, store } from '../Store.svelte';
    import Cart from '../components/configure/Cart.svelte';

    const location = useLocation();
</script>

<div>
    <Header />
    {#if !!$store.purchaseStatus.accountNumber && ($location.pathname.endsWith('/direccion') || $location.pathname.endsWith('/datos'))}
        <div
            class="alert"
            style="width: 90%; display: flex; justify-self: center;"
        >
            <p class="fw-semibold">
                <img
                    src="/assets/img/icons/warning.svg"
                    alt="Warning"
                    class="warning-icon"
                />
                Puedes consultar la información de este paso, pero no es posible
                editarla ahora que el proceso de contratación está en curso.
            </p>
        </div>
    {/if}
    <main
        class:secondary-font={$store.requestedServices.isSky}
        class:isSky={$store.requestedServices.isSky}
        class={$isStep5Or6 ? 'container-single' : 'container-main'}
    >
        <Router url="compra">
            <section class="content">
                <Route path="/configura" component={ConfigureServices} />
                <Route path="/datos" component={AccountDetails} />
                <Route path="/verificacion" component={VerificationCode} />
                <Route path="/direccion" component={ServiceAddress} />
                <Route path="/fecha" component={Calendar} />
                <Route path="/info" component={DataFiles} />
                <Route path="/resumen" component={Summary} />
                <Route path="/pago" component={Payment} />
                <Route path="/entrega" component={DeliveryType} />
                <Route path="/bienvenido" component={Welcome} />
            </section>
            <Cart />
        </Router>
    </main>
    <Footer />
</div>
